<section class="cta-banner">
  <div class="cta-banner__content">
    @if (eyebrow) {
    <p class="cta-banner__eyebrow">{{ eyebrow }}</p>
    }

    <h2 class="cta-banner__title"
        [class.cta-banner__title--animated]="titleAnimationActive()">{{ title }}</h2>

    @if (text) {
    <p class="cta-banner__text">{{ text }}</p>
    }
  </div>

  <div class="cta-banner__actions">
    @if (primaryLabel) {
    <a class="cta-banner__button cta-banner__button--primary" [routerLink]="primaryLink">
      {{ primaryLabel }}
    </a>
    }

    @if (secondaryLabel) {
    <a class="cta-banner__button cta-banner__button--secondary" [routerLink]="secondaryLink">
      {{ secondaryLabel }}
    </a>
    }
  </div>
</section>
